module.exports = __webpack_public_path__ + "img/waltily_logo_horizon.404cc899.svg";